const consent = {
  title: "ประกันเดินทางต่างประเทศ (ตามไลฟ์สไตล์)",
  description: `ประกันเดินทางต่างประเทศ…เที่ยวสบายใจได้ทุก “Life Style” ไม่ว่าเที่ยวกับครอบครัว หรือไปกับแก๊งเพื่อน ผู้ที่เดินทางท่องเที่ยวทุกเพศ ทุกวัย คุ้มครองตั้งแต่อายุ 1 – 80 ปี
  <br/><br/>
  ประเทศปลายทางที่ไม่คุ้มครอง : เกาหลีเหนือ, คิวบา, ซีเรีย, ซูดาน, บุรุนดี, ปากีสถาน, ปาเลสไตน์, รวันดา, ลิเบีย, เลบานอน, ไลบีเรีย, อัฟกานิสถาน, อาเซอร์ไบจาน, อิรัก, อิสราเอล, อิหร่าน, อุซเบกิสถาน, เอธิโอเปีย, เอริเทรีย, แองโกลา, แอลจีเรีย และเฮติ`,
  benefits: [
     {
      title: "แผนรายเดี่ยว",
      detail: "ความคุ้มครอง",
      items: [
        {
          index:
            "1. การเสียชีวิต การสูญเสียอวัยวะ สายตา หรือทุพพลภาพ ถาวรสิ้นเชิงเนื่องจากอุบัติเหตุ (ผู้เอาประกันภัยอายุ 1 - 80 ปี)",
          ranges: [
            {
              name: "ทุนประกันภัย (บาท)",
              plans: [
                {
                  name: "แบบที่ 1",
                  price: "1,000,000",
                },
                {
                  name: "แบบที่ 2",
                  price: "1,000,000",
                },
                {
                  name: "แบบที่ 3",
                  price: "1,000,000",
                },
              ],
            },
          ],
        },
        {
          index: "2. การรักษาพยาบาลในต่างประเทศ (ผู้เอาประกันภัยอายุ 1 - 80 ปี)",
          ranges: [
            {
              name: "ทุนประกันภัย (บาท)",
              plans: [
                {
                  name: "แบบที่ 1",
                  price: "1,000,000",
                },
                {
                  name: "แบบที่ 2",
                  price: "1,000,000",
                },
                {
                  name: "แบบที่ 3",
                  price: "1,000,000",
                },
              ],
            },
          ],
        },
        {
          index: "3. การรักษาพยาบาลต่อเนื่องในประเทศไทย (ผู้เอาประกันภัยอายุ 1 - 80 ปี)",
          ranges: [
            {
              name: "ทุนประกันภัย (บาท)",
              plans: [
                {
                  name: "แบบที่ 1",
                  price: "100,000",
                },
                {
                  name: "แบบที่ 2",
                  price: "100,000",
                },
                {
                  name: "แบบที่ 3",
                  price: "100,000",
                },
              ],
            },
          ],
        },
        {
          index: "4. ผลประโยชน์ชดเชยระหว่างการรักษาตัวในโรงพยาบาลในฐานะผู้ป่วยใน",
          ranges: [
            {
              name: "ทุนประกันภัย (บาท)",
              plans: [
                {
                  name: "แบบที่ 1",
                  price: "-",
                },
                {
                  name: "แบบที่ 2",
                  price: "-",
                },
                {
                  name: "แบบที่ 3",
                  price: "1,000 บาทต่อวันสูงสุด 20,000 บาท",
                },
              ],
            },
          ],
        },
        {
          index: "5. การเลื่อน หรือการบอกเลิกการเดินทาง",
          ranges: [
            {
              name: "ทุนประกันภัย (บาท)",
              plans: [
                {
                  name: "แบบที่ 1",
                  price: "-",
                },
                {
                  name: "แบบที่ 2",
                  price: "-",
                },
                {
                  name: "แบบที่ 3",
                  price: "200,000",
                },
              ],
            },
          ],
        },
        {
          index: "6. ค่าใช้จ่ายในการลดจำนวนวันเดินทาง",
          ranges: [
            {
              name: "ทุนประกันภัย (บาท)",
              plans: [
                {
                  name: "แบบที่ 1",
                  price: "-",
                },
                {
                  name: "แบบที่ 2",
                  price: "-",
                },
                {
                  name: "แบบที่ 3",
                  price: "200,000",
                },
              ],
            },
          ],
        },
        {
          index: "7. การจี้เครื่องบิน",
          ranges: [
            {
              name: "ทุนประกันภัย (บาท)",
              plans: [
                {
                  name: "แบบที่ 1",
                  price: "-",
                },
                {
                  name: "แบบที่ 2",
                  price: "-",
                },
                {
                  name: "แบบที่ 3",
                  price: "100,000",
                },
              ],
            },
          ],
        },
        {
          index: "8. ชดเชยความล่าช้าในการเดินทาง",
          ranges: [
            {
              name: "ทุนประกันภัย (บาท)",
              plans: [
                {
                  name: "แบบที่ 1",
                  price: "-",
                },
                {
                  name: "แบบที่ 2",
                  price: "1,000 บาททุกๆ 6 ชั่วโมงสูงสุด 5,000 บาท",
                },
                {
                  name: "แบบที่ 3",
                  price: "2,000 บาททุกๆ 6 ชั่วโมงสูงสุด 10,000 บาท",
                },
              ],
            },
          ],
        },
        {
          index: "9. การพลาดการต่อเที่ยวบิน",
          ranges: [
            {
              name: "",
              plans: [
                {
                  name: "แบบที่ 1",
                  price: "-",
                },
                {
                  name: "แบบที่ 2",
                  price: "-",
                },
                {
                  name: "แบบที่ 3",
                  price: "5,000",
                },
              ],
            },
          ],
        },
        {
          index:"10. การสูญเสีย หรือความเสียหายของกระเป๋าเดินทาง หรือทรัพย์สินส่วนตัว",
          ranges: [
            {
              name: "ทุนประกันภัย (บาท)",
              plans: [
                {
                  name: "แบบที่ 1",
                  price: "-",
                },
                {
                  name: "แบบที่ 2",
                  price: "5,000",
                },
                {
                  name: "แบบที่ 3",
                  price: "10,000",
                },
              ],
            },
          ],
        },
        {
          index:"11. ชดเชยการสูญหายของเงินส่วนตัว  (จ่ายส่วนเกินจาก 1,000 บาทแรก)",
          ranges: [
            {
              name: "ทุนประกันภัย (บาท)",
              plans: [
                {
                  name: "แบบที่ 1",
                  price: "-",
                },
                {
                  name: "แบบที่ 2",
                  price: "-",
                },
                {
                  name: "แบบที่ 3",
                  price: "1,000",
                },
              ],
            },
          ],
        },
        {
          index: "12. การล่าช้าของกระเป๋าเดินทาง",
          ranges: [
            {
              name: "ทุนประกันภัย (บาท)",
              plans: [
                {
                  name: "แบบที่ 1",
                  price: "-",
                },
                {
                  name: "แบบที่ 2",
                  price: "-",
                },
                {
                  name: "แบบที่ 3",
                  price: "5,000",
                },
              ],
            },
          ],
        },
        {
          index: "13. ความรับผิดต่อบุคคลภายนอก",
          ranges: [
            {
              name: "ทุนประกันภัย (บาท)",
              plans: [
                {
                  name: "แบบที่ 1",
                  price: "500,000",
                },
                {
                  name: "แบบที่ 2",
                  price: "500,000",
                },
                {
                  name: "แบบที่ 3",
                  price: "500,000",
                },
              ],
            },
          ],
        },
        {
          index: "14. ความคุ้มครองเอกสารการเดินทาง",
          ranges: [
            {
              name: "ทุนประกันภัย (บาท)",
              plans: [
                {
                  name: "แบบที่ 1",
                  price: "-",
                },
                {
                  name: "แบบที่ 2",
                  price: "-",
                },
                {
                  name: "แบบที่ 3",
                  price: "-",
                },
              ],
            },
          ],
        },
        {
          index: "15. ผลประโยชน์การขยายระยะเวลาโดยอัตโนมัติ",
          ranges: [
            {
              name: "ทุนประกันภัย (บาท)",
              plans: [
                {
                  name: "แบบที่ 1",
                  price: "30 วัน",
                },
                {
                  name: "แบบที่ 2",
                  price: "30 วัน",
                },
                {
                  name: "แบบที่ 3",
                  price: "30 วัน",
                },
              ],
            },
          ],
        },
        {
          index:
            "16. การเคลื่อนย้ายเพื่อการรักษาพยาบาลฉุกเฉิน หรือการเคลื่อนย้ายกลับประเทศภูมิลำเนาค่าใช้จ่ายในการส่งศพ หรืออัฐิกลับประเทศภูมิลำเนา",
          ranges: [
            {
              name: "ทุนประกันภัย (บาท)",
              plans: [
                {
                  name: "แบบที่ 1",
                  price: "30 ล้านบาท",
                },
                {
                  name: "แบบที่ 2",
                  price: "30 ล้านบาท",
                },
                {
                  name: "แบบที่ 3",
                  price: "30 ล้านบาท",
                },
              ],
            },
          ],
        },
        {
          index: "17. ชดเชยค่าโทรศัพท์ในกรณีฉุกเฉิน",
          ranges: [
            {
              name: "ทุนประกันภัย (บาท)",
              plans: [
                {
                  name: "แบบที่ 1",
                  price: "-",
                },
                {
                  name: "แบบที่ 2",
                  price: "-",
                },
                {
                  name: "แบบที่ 3",
                  price: "1,000",
                },
              ],
            },
          ],
        },
        {
          index: "18. ค่าใช้จ่ายในเดินทางเพื่อเยี่ยมผู้ป่วยที่โรงพยาบาล",
          ranges: [
            {
              name: "ทุนประกันภัย (บาท)",
              plans: [
                {
                  name: "แบบที่ 1",
                  price: "-",
                },
                {
                  name: "แบบที่ 2",
                  price: "-",
                },
                {
                  name: "แบบที่ 3",
                  price: "50,000",
                },
              ],
            },
          ],
        },
      ],
      timesHeaders: ["แบบที่ 1", "แบบที่ 2", "แบบที่ 3"], // ["Eco", "Good", "Best"]
      times: [
        {
          day: "1-4 วัน",
          asia: {
            "แบบที่ 1": 150,
            "แบบที่ 2": 190,
            "แบบที่ 3": 340,
          },
          worldwide: {
            "แบบที่ 1": 200,
            "แบบที่ 2": 230,
            "แบบที่ 3": 450,
          },
        },
        {
          day: "5-6 วัน",
          asia: {
            "แบบที่ 1": 200,
            "แบบที่ 2": 210,
            "แบบที่ 3": 440,
          },
          worldwide: {
            "แบบที่ 1": 260,
            "แบบที่ 2": 280,
            "แบบที่ 3": 560,
          },
        },
        
        {
          day: "7-8 วัน",
          asia: {
            "แบบที่ 1": 220,
            "แบบที่ 2": 240,
            "แบบที่ 3": 500,
          },
          worldwide: {
            "แบบที่ 1": 290,
            "แบบที่ 2": 310,
            "แบบที่ 3": 560,
          },
        },
        {
          day: "9-10 วัน",
          asia: {
            "แบบที่ 1": 240,
            "แบบที่ 2": 260,
            "แบบที่ 3": 550,
          },
          worldwide: {
            "แบบที่ 1": 320,
            "แบบที่ 2": 350,
            "แบบที่ 3": 700,
          },
        },
        {
          day: "11-14 วัน",
          asia: {
            "แบบที่ 1": 290,
            "แบบที่ 2": 310,
            "แบบที่ 3": 640,
          },
          worldwide: {
            "แบบที่ 1": 390,
            "แบบที่ 2": 420,
            "แบบที่ 3": 830,
          },
        },
        {
          day: "15-21 วัน",
          asia: {
            "แบบที่ 1": 360,
            "แบบที่ 2": 390,
            "แบบที่ 3": 800,
          },
          worldwide: {
            "แบบที่ 1": 480,
            "แบบที่ 2": 520,
            "แบบที่ 3": 1040,
          },
        },
        {
          day: "22-31 วัน",
          asia: {
            "แบบที่ 1": 470,
            "แบบที่ 2": 510,
            "แบบที่ 3": 1060,
          },
          worldwide: {
            "แบบที่ 1": 630,
            "แบบที่ 2": 640,
            "แบบที่ 3": 1270,
          },
        },
        {
          day: "32-40 วัน",
          asia: {
            "แบบที่ 1": 650,
            "แบบที่ 2": 700,
            "แบบที่ 3": 1320,
          },
          worldwide: {
            "แบบที่ 1": 870,
            "แบบที่ 2": 880,
            "แบบที่ 3": 1840,
          },
        },
        {
          day: "41-50 วัน",
          asia: {
            "แบบที่ 1": 690,
            "แบบที่ 2": 740,
            "แบบที่ 3": 1560,
          },
          worldwide: {
            "แบบที่ 1": 890,
            "แบบที่ 2": 960,
            "แบบที่ 3": 1980,
          },
        },
        {
          day: "51-60 วัน",
          asia: {
            "แบบที่ 1": 740,
            "แบบที่ 2": 800,
            "แบบที่ 3": 1880,
          },
          worldwide: {
            "แบบที่ 1": 920,
            "แบบที่ 2": 1040,
            "แบบที่ 3": 2380,
          },
        },
        {
          day: "61-70 วัน",
          asia: {
            "แบบที่ 1": 920,
            "แบบที่ 2": 990,
            "แบบที่ 3": 2150,
          },
          worldwide: {
            "แบบที่ 1": 1130,
            "แบบที่ 2": 1220,
            "แบบที่ 3": 2590,
          },
        },
        {
          day: "71-80 วัน",
          asia: {
            "แบบที่ 1": 1030,
            "แบบที่ 2": 1110,
            "แบบที่ 3": 2450,
          },
          worldwide: {
            "แบบที่ 1": 1170,
            "แบบที่ 2": 1330,
            "แบบที่ 3": 2670,
          },
        },
        {
          day: "81-90 วัน",
          asia: {
            "แบบที่ 1": 1140,
            "แบบที่ 2": 1300,
            "แบบที่ 3": 2890,
          },
          worldwide: {
            "แบบที่ 1": 1230,
            "แบบที่ 2": 1480,
            "แบบที่ 3": 3080,
          },
        },
        {
          day: "91-120 วัน",
          asia: {
            "แบบที่ 1": 1480,
            "แบบที่ 2": 1590,
            "แบบที่ 3": 3640,
          },
          worldwide: {
            "แบบที่ 1": 1680,
            "แบบที่ 2": 1920,
            "แบบที่ 3": 4060,
          },
        },
        {
          day: "121-150 วัน",
          asia: {
            "แบบที่ 1": 1730,
            "แบบที่ 2": 1970,
            "แบบที่ 3": 4070,
          },
          worldwide: {
            "แบบที่ 1": 2160,
            "แบบที่ 2": 2460,
            "แบบที่ 3": 4920,
          },
        },
        {
          day: "151-180 วัน",
          asia: {
            "แบบที่ 1": 2100,
            "แบบที่ 2": 2260,
            "แบบที่ 3": 4500,
          },
          worldwide: {
            "แบบที่ 1": 2300,
            "แบบที่ 2": 2900,
            "แบบที่ 3": 5330,
          },
        },
        {
          day:
            "1 ปี  (ไม่เกิน 90 วันต่อการเดินทาง)",
          asia: {
            "แบบที่ 1": 1465,
            "แบบที่ 2": 1475,
            "แบบที่ 3": 3120,
          },
          worldwide: {
            "แบบที่ 1": 1780,
            "แบบที่ 2": 2050,
            "แบบที่ 3": 3200,
          },
        },
        {
          day:
            "1 ปี  (ไม่เกิน 180 วันต่อการเดินทาง)",
          asia: {
            "แบบที่ 1": 2520,
            "แบบที่ 2": 2830,
            "แบบที่ 3": 4680,
          },
          worldwide: {
            "แบบที่ 1": 2970,
            "แบบที่ 2": 3380,
            "แบบที่ 3": 5840,
          },
        },
      ],
    },
  ],
  conditions: [
    {
      title: "",
      detail: "เงื่อนไขการรับประกันภัย",
      items: [
        {
          index: "1. ผู้ขอเอาประกันภัยต้องเริ่มต้นการเดินทางจากประเทศไทย",
        },
        {
          index: "2. รับประกันอายุ 1-80 ปี",
        },
        {
          index:
            "3. แผนประกันแบบรายปี คุ้มครองการเดินทางสูงสุด 90 วัน หรือ 180 วันต่อการเดินทางในแต่ละครั้ง โดยไม่จำกัดจำนวนครั้งต่อปี",
        },
        {
          index:
            "4. ผู้ขอเอาประกันภัยสามารถขอเอาประกันภัยภายใต้กรมธรรม์ประกันภัยการเดินทางนี้ได้เพียง 1 ฉบับในช่วงเวลาเดินทางเดียวกัน",
        },
        {
          index:
            "5. ผู้ขอเอาประกันภัยจะต้องเริ่มต้นเดินทางจากประเทศไทยเท่านั้น และสิ้นสุดที่ประเทศไทยเท่านั้น",
        },
        {
          index:
            "6. ผู้ขอเอาประกันภัยจะต้องมีสุขภาพแข็งแรงและสมบรูณ์ ไม่มีอวัยวะส่วนใดส่วนหนึ่งพิการ",
        },
        {
          index: "",
        },
      ],
    },
  ],
  exceptions: [
    {
      title: "",
      detail: "ข้อยกเว้นสำคัญ",
      items: [
        {
          index:
            "1. ผู้เอาประกันภัยฆ่าตัวตาย พยายามฆ่าตัวตาย หรือการทำร้ายร่างกายตนเอง",
        },
        {
          index:
            "2. สภาพที่เป็นมาก่อนการเอาประกันภัย (Pre-existing Conditions)",
        },
        {
          index:
            "3. กรณีที่ผู้เอาประกันภัยอยู่ภายใต้ฤทธิ์สุรา ยาเสพติด สารเสพติดให้โทษ",
        },
        {
          index:
            "4. สงคราม การรุกราน การกระทำที่มุ่งร้ายของศัตรูต่างชาติ หรือการกระทำที่มุ่งร้ายคล้ายสงคราม สงครามกลางเมือง การปฏิวัติ การจลาจล การนัดหยุดงาน การก่อความวุ่นวาย หรือต่อต้านรัฐบาล การประกาศกฎอัยการศึก การก่อการร้าย",
        },
        {
          index:
            "5. ขณะที่ผู้เอาประกันภัยปฏิบัติหน้าที่เป็นนักบิน, พนักงานต้อนรับบนเครื่องบิน, ทหาร, ตำรวจ หรืออาสาสมัคร และเข้าปฏิบัติการในสงคราม หรือปราบปราม",
        },
        {
          index:
            "6. ขณะที่ผู้เอาประกันภัยเข้าร่วมเล่นหรือฝึกซ้อมหรือแข่งขันกีฬาอาชีพ",
        },
      ],
    },
    {
      title: "",
      detail:
        "กรมธรรม์ประกันภัยนี้ไม่คุ้มครองผู้ที่เดินทางไปหรือการเดินทางภายในประเทศต่อไปนี้: ",
      items: [
        {
          index:
            "เกาหลีเหนือ, คิวบา, ซีเรีย, ซูดาน, บุรุนดี, ปากีสถาน, ปาเลสไตน์, รวันดา, ลิเบีย, เลบานอน, ไลบีเรีย, อัฟกานิสถาน, อาเซอร์ไบจาน, อิรัก, อิสราเอล, อิหร่าน, อุซเบกิสถาน, เอธิโอเปีย, เอริเทรีย, แองโกลา, แอลจีเรีย และเฮติ",
        },
      ],
    },
    {
      title: "",
      detail: "**หมายเหตุ",
      items: [
        {
          index:
            "ข้อ 2 การรักษาพยาบาลในต่างประเทศ จากการบาดเจ็บจากอุบัติเหตุ หรือการเจ็บป่วยที่เกิดขึ้นอย่างกะทันหัน จนเป็นเหตุให้ต้องได้รับการรักษาพยาบาล ไม่ว่าจะเป็นฐานะผู้ป่วยในหรือผู้ป่วยนอก",
        },
        {
          index:
            "ข้อ 3 การรักษาพยาบาลต่อเนื่องในประเทศไทยคุ้มครองค่ารักษาพยาบาลที่จำเป็นในการรักษาหรือการติดตามอาการในประเทศไทย",
        },
        {
          index:
            "1. กรณีไม่เคยรักษาพยาบาลในต่างประเทศมาก่อน ต้องรับการรักษาในประเทศไทยภายใน 1 วัน นับจากเดินทางมาถึงประเทศไทย และรักษาต่อเนื่องไม่เกิน 7 วัน",
        },
        {
          index:
            "2. กรณีเคยรักษาในต่างประเทศมาก่อน ต้องเข้ารับการรักษาภายใน 7 วันนับจากเดินทางกลับถึงประเทศไทย",
        },
        {
          index:
            "ข้อ 4. ผลประโยชน์ชดเชยระหว่างการรักษาตัวในโรงพยาบาลในฐานะผู้ป่วยใน บริษัทจะจ่ายผลประโยชน์ชดเชยรายวันให้เป็นจำนวนต่อวัน ตามจำนวนวันที่นอนรักษาตัวเป็นผู้ป่วยในในโรงพยาบาล ในต่างประเทศจริง สูงสุดไม่เกิน 20 วัน",
        },
        {
          index:
            "ข้อ 5. การเลื่อน หรือการบอกเลิกการเดินทาง ซึ่งเกิดขึ้นภายใน 30 วัน ก่อนวันออกเดินทาง (ยกเว้นสาเหตุตามข้อ 3) อันมีสาเหตุมาจาก",
        },
        {
          index:
            "1. การเสียชีวิต หรือการบาดเจ็บสาหัสหรือการเจ็บป่วยหนักของผู้เอาประกันภัย หรือสมาชิกของครอบครัว",
        },
        {
          index:
            "2. การเกิดการนัดหยุดงานขึ้นโดยไม่คาดคิด การจลาจล สงครามกลางเมือง ซึ่งเป็นเหตุการณ์ที่อยู่นอกเหนือการควบคุมของผู้เอาประกันภัย",
        },
        {
          index:
            "3. เมื่อที่พักอาศัยของผู้เอาประกันภัยที่ใช้เป็นที่อยู่อาศัยถาวรได้รับความเสียหายร้ายแรงจาก ไฟไหม้ น้ำท่วม พายุใต้ฝุ่น แผ่นดินไหว ภายใน 7 วัน ก่อนวันออกเดินทาง",
        },
        {
          index:
            "4. ได้รับหมายเรียกให้เป็นพยานที่ศาล หรือได้รับหมายบังคับจากศาล",
        },
        {
          index:
            "ข้อ 6. ค่าใช้จ่ายในการลดจำนวนวันเดินทาง ให้ความคุ้มครองค่าใช้จ่ายที่เพิ่มขึ้นที่ได้ชำระไปสำหรับค่าใช้จ่ายในการเดินทาง ค่าที่พัก และค่าอาหารในระหว่างระยะเวลาการเดินทาง กรณีต้องเดินทางกลับประเทศภูมิลำเนาก่อนกำหนดเนื่องจาก",
        },
        {
          index:
            "1. ผู้เอาประกันภัยได้รับการบาดเจ็บสาหัสหรือการป่วยหนัก และแพทย์แนะนำให้เดินทางกลับ",
        },
        {
          index:
            "2. สมาชิกของครอบครัว หรือเพื่อนเดินทางของผู้เอาประกันภัย เสียชีวิต หรือได้รับการบาดเจ็บ หรือการเจ็บป่วยโดยไม่คาดหมาย",
        },
        {
          index:
            "3. ภัยธรรมชาติ ได้แก่ พายุไต้ฝุ่น หรือแผ่นดินไหว ทำให้ผู้เอาประกันภัยไม่สามารถเดินทางตามกำหนดการต่อไปได้",
        },
        {
          index:
            "4. การนัดหยุดงาน การจลาจล การก่อความวุ่นวายทางการเมืองที่ไม่คาดหมายและอยู่นอกเหนือ การควบคุมของผู้เอาประกันภัย หรือ",
        },
        {
          index: "5. การถูกกักด่านกักกันเชื้อโรคตามคำแนะนำของแพทย์",
        },
        {
          index:
            "ข้อ 8. ชดเชยความล่าช้าในการเดินทาง กรณีการเดินทางล่าช้าออกไปจากกำหนดการเดินทางเป็นเวลาอย่างน้อย 6 ชั่วโมง ติดต่อกัน เนื่องจากสภาพอากาศไม่อำนวย เครื่องอุปกรณ์ไม่สมบูรณ์ หรือการนัดหยุดงาน",
        },
        {
          index:
            "ข้อ 9. การพลาดการต่อเที่ยวบิน กรณีที่พลาดการเดินทางต่อในต่างประเทศ ณ จุดที่ต้องมีการเปลี่ยนถ่ายยานพาหนะ อันเนื่องมาจากการล่าช้า 8 ชั่วโมง",
        },
        {
          index:
            "ข้อ 11. ชดเชยการสูญหายของเงินส่วนตัว จะต้องรับผิดชอบความเสียหายส่วนแรกเป็นจำนวนเงิน 1,000 บาท ของการสูญหาย แต่ละครั้งและทุกๆ ครั้งที่เกิดการสูญหาย",
        },
        {
          index: "ข้อ 12. การล่าช้าของกระเป๋าเดินทาง",
        },
        {
          index:
            "1. หลังจากมาถึงจุดหมายปลายทางในต่างประเทศเกินกว่า 8 ชั่วโมง จะชดใช้เงินคืนตามที่ได้สำรองจ่ายไปจริงล่วงหน้าสูงสุดไม่เกินร้อยละ 20 ของจำนวนเงินเอาประกันภัย",
        },
        {
          index:
            "2. หลังจากมาถึงจุดหมายปลายทางในต่างประเทศเกินกว่า 16 ชั่วโมง จะชดใช้เงินคืนเป็นจำนวนเงินที่เพิ่มเติมจากข้อ 1 อีกไม่เกินร้อยละ 30 ของจำนวนเงินเอาประกันภัย",
        },
        {
          index:
            "3. หลังจากมาถึงจุดหมายปลายทางในต่างประเทศเกินกว่า 24 ชั่วโมง จะชดใช้เงินคืนเป็นจำนวนเงินที่เพิ่มเติมจากข้อ 2 อีกไม่เกินร้อยละ 50 ของจำนวนเงินเอาประกันภัย",
        },
        {
          index:
            "ข้อ 15. การขยายระยะเวลาโดยอัตโนมัติ กรณีที่การเดินทางในเที่ยวกลับต้องล่าช้าออกไปเนื่องจากมีเหตุการณ์อยู่นอกเหนือความควบคุม จะขยายระยะเวลาของการประกันภัยเท่าที่จำเป็นสำหรับให้ ไม่เกิน 30 วัน",
        },
        {
          index:
            "ข้อ 17. ชดเชยค่าโทรศัพท์ในกรณีฉุกเฉิน เพื่อจุดประสงค์ในการติดต่อขอใช้บริการของ บริษัท AWP Services (Thailand) Co.,Ltd. เท่านั้น",
        },
        {
          index:
            "ข้อ 18.ค่าใช้จ่ายในเดินทางเพื่อเยี่ยมผู้ป่วยที่โรงพยาบาล กรณีที่เข้ารับการรักษาตัวเป็นผู้ป่วยในในโรงพยาบาล ในต่างประเทศติดต่อกันนานเกิน 5 วัน และไม่มีบุคคลที่บรรลุนิติภาวะอยู่ด้วยจะจ่ายค่าเดินทางเฉพาะค่าเดินทางรวมทั้งจ่ายค่าที่พัก และค่าอาหารสูงสุด 50,000 บาท",
        },
      ],
    },
  ],
  services: [
    {
      title: "",
      detail:
        "ศูนย์บริการลูกค้า (Customer Service Center)",
      items: [
        {
          index:
            "<li> ทาง Call Center โทร.1484",
        },
      ],
    },
  ],
};

export default consent;
